// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimRepaymentStartDto
 */
export interface IClaimRepaymentStartDto {
    /**
     * 
     * @type {number}
     * @memberof IClaimRepaymentStartDto
     */
    payment_method_id: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimRepaymentStartDto
     */
    repayment_amount?: number;
}

/**
 * Check if a given object implements the IClaimRepaymentStartDto interface.
 */
export function instanceOfIClaimRepaymentStartDto(value: object): value is IClaimRepaymentStartDto {
    if (!('payment_method_id' in value) || value['payment_method_id'] === undefined) return false;
    return true;
}

export function IClaimRepaymentStartDtoFromJSON(json: any): IClaimRepaymentStartDto {
    return IClaimRepaymentStartDtoFromJSONTyped(json, false);
}

export function IClaimRepaymentStartDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimRepaymentStartDto {
    if (json == null) {
        return json;
    }
    return {
        
        'payment_method_id': json['payment_method_id'],
        'repayment_amount': json['repayment_amount'] == null ? undefined : json['repayment_amount'],
    };
}

export function IClaimRepaymentStartDtoToJSON(json: any): IClaimRepaymentStartDto {
    return IClaimRepaymentStartDtoToJSONTyped(json, false);
}

export function IClaimRepaymentStartDtoToJSONTyped(value?: IClaimRepaymentStartDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payment_method_id': value['payment_method_id'],
        'repayment_amount': value['repayment_amount'],
    };
}

